import * as Actions from '../../../Modules/CmsActions'
import type { Document } from '../../../Types'

const initialState: Document[] = []

const DocumentReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.FINISH_FETCH_ALL_DOCUMENT:
      return action.payload.documents?.data || []

    case Actions.LOGOUT:
      return initialState

    default:
      return state
  }
}

export default DocumentReducer
